import { ReactNode } from 'react';
import Tooltip from './Tooltip';
import { GLOSSARY, type GlossaryKey } from '../../lib/glossary';

interface Props {
  /** Glossary key; the tooltip shows that entry's definition. */
  k?: GlossaryKey;
  /** Or an inline definition when the term is local to one screen. */
  def?: ReactNode;
  children?: ReactNode;
  className?: string;
  /** Hide the dotted underline (for tab labels and headings that carry their own style). */
  plain?: boolean;
}

/**
 * A system term with its definition on hover or focus. Renders the glossary
 * term itself when no children are given.
 */
export default function Term({ k, def, children, className = '', plain = false }: Props) {
  const entry = k ? GLOSSARY[k] : null;
  const content = def ?? entry?.def;
  const label = children ?? entry?.term ?? '';
  if (!content) return <>{label}</>;
  return (
    <Tooltip content={content} className={`${plain ? '' : 'border-b border-dotted border-bodydark2'} ${className}`}>
      {label}
    </Tooltip>
  );
}
